/**
 * Kohutt™ Theme JavaScript
 * File: assets/kohutt-theme.js
 *
 * Handles: sticky header, mobile nav drawer, product gallery, accordion
 * Vanilla JS only — no frameworks required.
 */

(function () {
  'use strict';

  /* ─── STICKY HEADER ─── */
  function initStickyHeader() {
    const header = document.querySelector('.kohutt-header');
    if (!header) return;

    let lastScroll = 0;
    window.addEventListener('scroll', function () {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ─── MOBILE NAV DRAWER ─── */
  function initMobileNav() {
    const openBtn  = document.querySelector('.kohutt-header__hamburger');
    const drawer   = document.querySelector('.kohutt-nav-drawer');
    const closeBtn = drawer && drawer.querySelector('.kohutt-nav-drawer__close');
    const overlay  = drawer && drawer.querySelector('.kohutt-nav-drawer__overlay');

    if (!openBtn || !drawer) return;

    function openDrawer() {
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      closeBtn && closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      document.body.style.overflow = '';
      openBtn.focus();
    }

    openBtn.addEventListener('click', openDrawer);
    closeBtn && closeBtn.addEventListener('click', closeDrawer);
    overlay && overlay.addEventListener('click', closeDrawer);

    // Trap focus inside drawer
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ─── PRODUCT GALLERY ─── */
  function initProductGallery() {
    const gallery    = document.querySelector('.kohutt-product-gallery');
    if (!gallery) return;

    const mainImg    = gallery.querySelector('.kohutt-product-gallery__main img');
    const thumbBtns  = gallery.querySelectorAll('.kohutt-product-gallery__thumb');

    if (!mainImg || thumbBtns.length === 0) return;

    thumbBtns.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        const src    = this.dataset.src;
        const srcset = this.dataset.srcset;
        const alt    = this.dataset.alt;

        if (src) {
          mainImg.style.opacity = '0';
          mainImg.style.transition = 'opacity 0.2s';
          setTimeout(function () {
            mainImg.src    = src;
            if (srcset) mainImg.srcset = srcset;
            if (alt)    mainImg.alt    = alt;
            mainImg.style.opacity = '1';
          }, 180);
        }

        thumbBtns.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  /* ─── ACCORDION ─── */
  function initAccordions() {
    const items = document.querySelectorAll('.kohutt-accordion__item');
    items.forEach(function (item) {
      const trigger  = item.querySelector('.kohutt-accordion__trigger');
      const content  = item.querySelector('.kohutt-accordion__content');
      if (!trigger || !content) return;

      // Set ARIA
      const id = 'kohutt-acc-' + Math.random().toString(36).substr(2, 6);
      content.id = id;
      trigger.setAttribute('aria-controls', id);
      trigger.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');

      trigger.addEventListener('click', function () {
        const isOpen = item.classList.toggle('open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        // Close siblings
        items.forEach(function (sibling) {
          if (sibling !== item) {
            sibling.classList.remove('open');
            const sibTrigger = sibling.querySelector('.kohutt-accordion__trigger');
            if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });

    // Open first accordion item by default
    if (items.length > 0) {
      items[0].classList.add('open');
      const firstTrigger = items[0].querySelector('.kohutt-accordion__trigger');
      if (firstTrigger) firstTrigger.setAttribute('aria-expanded', 'true');
    }
  }

  /* ─── VARIANT SELECTOR ─── */
  function initVariantSelector() {
    const swatchGroups = document.querySelectorAll('.kohutt-product-option__swatches');
    swatchGroups.forEach(function (group) {
      const btns = group.querySelectorAll('.kohutt-swatch-btn');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (this.disabled) return;
          btns.forEach(function (b) {
            b.classList.remove('active');
            b.setAttribute('aria-checked', 'false');
          });
          this.classList.add('active');
          this.setAttribute('aria-checked', 'true');
        });
      });
    });
  }

  /* ─── ADD TO CART FEEDBACK ─── */
  function initATCButton() {
    const atcBtn = document.querySelector('.kohutt-atc-btn');
    if (!atcBtn) return;

    // Listen for Shopify's cart:add event (dispatched by Dawn's cart JS)
    document.addEventListener('cart:add', function () {
      const original = atcBtn.textContent;
      atcBtn.textContent = '✓ Added to Bag';
      atcBtn.style.background = 'var(--kohutt-moss)';
      setTimeout(function () {
        atcBtn.textContent = original;
        atcBtn.style.background = '';
      }, 2200);
    });
  }

  /* ─── INIT ─── */
  function init() {
    initStickyHeader();
    initMobileNav();
    initProductGallery();
    initAccordions();
    initVariantSelector();
    initATCButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
